import { render, staticRenderFns } from "./down.vue?vue&type=template&id=4ef6f98a"
import script from "./down.vue?vue&type=script&lang=js"
export * from "./down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef6f98a')) {
      api.createRecord('4ef6f98a', component.options)
    } else {
      api.reload('4ef6f98a', component.options)
    }
    module.hot.accept("./down.vue?vue&type=template&id=4ef6f98a", function () {
      api.rerender('4ef6f98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/policy-set/down.vue"
export default component.exports